var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-btn',{staticClass:"primary",on:{"click":function($event){return _vm.crearDocumento()}}},[_vm._v("Generar La Factura")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }